import { defineStore } from 'pinia'
import {getSecureCookieOptions} from "@/utils/cookieOptions";

export const useCheckoutAuthStore = defineStore('checkoutAuthStore', {
  state: () => ({
    customerId: null,
    contactPersonId: null,
    jwt: null,
  }),
  getters: {
    isLoggedIn(state){
      return state.customerId != null
        && state.contactPersonId != null
        && state.jwt != null
        && this.isJwtValid
    },
    isJwtValid(state) {
      if (!state.jwt) return false

      try {
        // Get the payload part of the JWT (second segment)
        const payload = state.jwt.split('.')[1]
        // Decode the base64 payload
        const decodedPayload = JSON.parse(atob(payload))
        // Check if the token has expired
        const currentTime = Math.floor(Date.now() / 1000)
        return decodedPayload.exp > currentTime
      } catch (error) {
        return false
      }
    }
  },
  actions: {
    login({token, customerId, contactPersonId}) {
      this.setJwt(token)
      this.setCustomerId(customerId)
      this.setContactPersonId(contactPersonId)
    },
    setCustomerId(customerId) {
      this.customerId = customerId
    },
    setContactPersonId(contactPersonId) {
      this.contactPersonId = contactPersonId
    },
    setJwt(jwt) {
      this.jwt = jwt
    },
    logout() {
      this.setCustomerId(null);
      this.setContactPersonId(null);
      this.setJwt(null);
    }
  },
  persist: [
    {
      storage: piniaPluginPersistedstate.cookies(getSecureCookieOptions()),
      pick: ['customerId', 'contactPersonId', 'jwt'],
    }
  ]
})
